let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dXU8n")).then(() => parcelRequire('14MtF'));